import type { ButtonProps } from '@mantine/core'
import { Button } from '@mantine/core'
import { Consts, semverString, useGlobalState, useMultiCountPress } from '@opsopti/shared'
import { ModalStatus } from '@opsopti/shared/src/services/state/UIStore'
import { observer } from 'mobx-react-lite'

import { version } from '../../package.json'

export const VersionButton = observer(function VersionButton(props: ButtonProps) {
  const { configStore, uiStore } = useGlobalState()

  const versionMultiCountPressProps = useMultiCountPress(
    () => uiStore.setProp('devModalStatus', ModalStatus.Open),
    Consts.isDev ? 1 : 10,
    500,
  )

  return (
    <Button size="sm" color="gray" variant="transparent" {...versionMultiCountPressProps} {...props}>
      v{semverString({ version, env: configStore.env })}
    </Button>
  )
})
